export enum AlertType {
    FirstTimeUser = 'FirstTimeUser',
    CheckinAssistance = 'CheckinAssistance',
}

export enum AlertSeverity {
    Urgent = 'Urgent',
    Info = 'Info',
}

export interface IAlertData {
    type: AlertType;
    severity: AlertSeverity;
    title: string;
    message: string;
    gymName: string;
    resolved?: boolean;
    createdAt?: Date;
    userId?: string;
    location?: string;
}
